/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentUseCasesControllerGetReprocessOverridesQueryResponse } from "../../models/documentUseCasesController/DocumentUseCasesControllerGetReprocessOverrides";

function getDocumentUseCasesControllerGetReprocessOverridesUrl() {
  const res = { method: 'GET', url: `/api/v1/documents/processings/reprocess-overrides` as const }  
  return res
}

/**
 * @description Returns each overridable setting with its current deployed default and accepted bounds, keyed to the step it applies to. Read this rather than hardcoding defaults — they change with config.
 * @summary Get the per-run overrides the reprocess API accepts
 * {@link /api/v1/documents/processings/reprocess-overrides}
 */
export async function documentUseCasesControllerGetReprocessOverrides(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentUseCasesControllerGetReprocessOverridesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getDocumentUseCasesControllerGetReprocessOverridesUrl().url.toString(), ... requestConfig })  
  return res.data
}